export default {
  "HitPaw Add Music to Audio Online": "HitPaw Musik zu Audio Online hinzufügen",
  "Add BGM to Audio without any difficulties.": "Hintergrundmusik zu Audio ohne Schwierigkeiten hinzufügen.",
  "Add New": "Neue hinzufügen",
  "Format": "Format",
  "Add tracks": "Tracks hinzufügen",

};
